var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g(_vm._b({attrs:{"selected":_vm.value,"headers":_vm.headers,"actions":_vm.actions,"list":_vm.list},scopedSlots:_vm._u([{key:"item.school_code",fn:function(ref){
var v = ref.value;
return [_c('span',{staticClass:"BTablePublicationFormdata__link",domProps:{"textContent":_vm._s(v)}})]}}])},'BTable',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }